export default __webpack_public_path__ + "static/media/blog-hillside-retaining-004.e7b60d7c.jpg";